<template>
  <div style="">
    <rabbey-toolbox :filterables="true" @filter-search="search = $event">
    </rabbey-toolbox>
    <el-row>
      <rabbey-table3
        ref="inven"
        :data="items"
        :border="true"
        :stripe="true"
        :search="search"
        @rtable-push-action="handleCommand"
        v-loading="loading"
        :columns="columns"
        :actions="actions"
      >
      </rabbey-table3>
    </el-row>
    <el-drawer
      title="Solicitud de Compras"
      :visible.sync="drawerinve"
      size="50%"
    >
      <el-form
        :model="datainvForm"
        label-position="left"
        size="mini"
        label-width="175px"
      >
        <el-row :gutter="20" type="flex column">
          <el-col :span="4" :xs="5" :sm="24" :md="24" :lg="8">
            <el-form-item label="N°" style="position: relative; left: 10px">
              <el-input v-model="datainvForm.NoIn" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item
              label="Nombre de descripcion"
              style="position: relative; left: 10px; top: 12px"
            >
              <el-input
                v-model="datainvForm.Nam"
                :disabled="true"
                style="width: 200px"
              />
            </el-form-item>

            <el-form-item
              label="Inventario"
              style="position: relative; left: 10px; top: 18px"
            >
              <el-input
                v-model="datainvForm.FullQuanti"
                :disabled="true"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="Cantidad minima de Pedidos"
              style="position: relative; left: 10px; top: 20px"
            >
              <el-input
                v-model="datainvForm.MiOrderQ"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4" :xs="5" :sm="24" :md="24" :lg="8">
            <el-form-item
              label="Inventario Maximo"
              style="position: relative; left: 100px"
            >
              <el-input v-model="datainvForm.Minven" :disabled="true">
              </el-input>
            </el-form-item>

            <el-form-item
              label="Punto de Pedido"
              style="position: relative; left: 100px"
            >
              <el-input v-model="datainvForm.RePoint" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-collapse accordion style="padding: 15px">
        <el-collapse-item name="1">
          <template slot="title">
            Formulario de Solicitud de Compras<i
              class="header-icon el-icon-s-order"
            ></i>
          </template>
          <el-form
            ref="forminve"
            :model="datainvForm"
            label-width="190px"
            size="mini"
          >
            <el-form-item label="N°">
              <el-input v-model="datainvForm.NoIn" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="Descripcion">
              <el-input v-model="datainvForm.Nam" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="Inventario">
              <el-input-number
                v-model="datainvForm.FullQuanti"
                :min="0"
                :max="10000"
                :disabled="true"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="Cantidad minima de Pedidos">
              <el-input-number
                v-model="datainvForm.MiOrderQ"
                :min="1"
                :max="5000"
                :disabled="true"
              ></el-input-number>
            </el-form-item>

            <el-form-item label="Inventario Maximo">
              <el-input-number
                v-model="datainvForm.Minven"
                :min="1"
                :max="5000"
                :disabled="true"
              ></el-input-number>
            </el-form-item>

            <el-form-item label="Punto de Pedido">
              <el-input-number
                v-model="datainvForm.RePoint"
                :min="1"
                :max="5000"
                :disabled="true"
              ></el-input-number>
            </el-form-item>
            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit" :disabled="true"
                >Create</el-button
              >
              <el-button :disabled="true">Cancel</el-button>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </el-drawer>
  </div>
</template>

<script>
//import { formatMonto } from "../../../utils";
import InventoryColorFormat from "./InventoryColorFormat.vue";
import InputColumn from "@/components/functionals/InputColumn.vue";

export default {
  name: "InventoryIntemp",
  // functional: true,
  data() {
    return {
      search: "",
      CompanyCode: this.$store.state.user.user.CompanySelected,
      // Typec:"",
      datainvForm: {},
      amountToBuy: 0,
      loading: false,
      drawerinve: false,
      items: [],
      columns: [
        {
          prop: "NoIn",
          label: "N° ",
          "min-width": 50,
          align: "center",
          sortable: true
        },
        {
          prop: "Nam",
          label: "Nombre de descripcion",
          "min-width": 250,
          sortable: true
        },
        {
          prop: "FullQuanti",
          label: "Inventario",
          "min-width": 50,
          align: "center",
          sortable: true,
          formatter: InventoryColorFormat
        },
        {
          prop: "MiOrderQ",
          label: "Cantidad minima de Pedidos",
          "min-width": 110,
          align: "center",
          sortable: true,
          formatter: InputColumn,
          attrs: {
            inputValue: "invQTY",
            disabled: () => false,
            UpdateInventoryQTY: this.UpdateInventoryQTY
          }
          //formatter: (row) => formatMonto(row.MiOrderQ)
        },
        {
          prop: "Minven",
          label: "Inventario Maximo",
          "min-width": 80,
          align: "center",
          sortable: true,
          formatter: InputColumn,
          attrs: {
            inputValue: "invQTY",
            disabled: () => false,
            UpdateInventoryQTY: this.UpdateInventoryQTY
          }
          //formatter: (row) => formatMonto(row.Minven)
        },

        {
          prop: "RePoint",
          label: "Punto de Pedido",
          "min-width": 80,
          align: "center",
          sortable: true,
          formatter: InputColumn,
          attrs: {
            inputValue: "invQTY",
            disabled: () => false,
            UpdateInventoryQTY: this.UpdateInventoryQTY
          }
          //formatter: (row) => formatMonto(row.RePoint)
        }
      ],
      actions: [
        {
          icon: "el-icon-circle-plus",
          label: "Solicitud de Compra",
          command: "view"
        }
      ]
    };
  },
  created() {
    this.getItemsInven();
  },

  methods: {
    getItemsInven() {
      this.loading = true;

      const params = {
        CompanyCode: this.CompanyCode
      };
      this.$http
        .get("/api/invoices/GetInventoryI", {
          params
        })
        .then(({ data }) => {
          this.items = data;

          // console.log("inve dejense ver:", this.items);
        })
        .catch((error) => {
          this.$message.error("Error al consultar datos del inventario");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // this is for the button of number form
    // handleChange(value) {
    //     console.log(value)
    //   },

    onSubmit() {},

    handleCommand(option) {
      switch (option.command) {
        case "view": {
          this.drawerinve = true;
          this.datainvForm = option.row;
          // console.log('klk row', option.row.NoIn);
          // console.log('klk data onj', this.datainvForm);
          break;
        }
      }
    },
    UpdateInventoryQTY(newValue, selectedRow, column) {
      //console.log("funciono el callback")
      //console.log("newValue: ",newValue, "\nselectedRow: ", selectedRow, "\ncolumn: ", column)
      let optionCol;
      switch (column) {
        case "MiOrderQ":
          optionCol = "minOrd";
          break;

        case "Minven":
          optionCol = "maxInv";
          break;

        case "RePoint":
          optionCol = "RePoin";
          break;

        default:
          break;
      }

      const params = {
        productId: selectedRow.NoIn,
        newValue: newValue,
        option: optionCol,
        CompanyCode: this.currentCompany
      };

      this.$http
        .put("/api/invoices/UpdateInventoryQTYs", params)
        .then((resp) => {
          //console.log("actualizado: ", resp)
          if (resp.data > 0) {
            this.$message({
              showClose: true,
              message: " Campo actualizado exitosamente !",
              type: "success"
            });
          }
        })
        .catch((err) => {
          console.error("Error actualizando campo en inventario: ", err);
          this.$message({
            showClose: true,
            message: err,
            type: "error"
          });
        });
    }
  }
};
</script>
<style></style>
